/**
 * The carrier-invoices module's routes, owned by the feature (D5). Mirrors
 * `src/features/payouts/routes.tsx` — `src/app/router.tsx` spreads this array.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const CarrierInvoicesPage = lazy(() => import('./CarrierInvoicesPage'));

export const carrierInvoicesRoutes: RouteObject[] = [
    { path: 'carrier-invoices', element: <CarrierInvoicesPage /> },
];
